import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export const spinningLogo = (selector) => {
    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.normalizeScroll(true);

    jQuery(document).ready(function ($) {
        if ($(selector).length === 0) return;

        gsap.to(selector, {
            rotation: "+=180",
            ease: "none",
            scrollTrigger: {
                trigger: "body",
                start: "top top",
                end: "bottom bottom",
                scrub: 1,
                invalidateOnRefresh: true
            }
        });

        ScrollTrigger.refresh();
    });
};